import QuotesFeedView from 'components/QuotesFeedView'
import { QuoteFeed } from 'interfaces/Content/QuoteFeed'
import { useMemo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'
import { saveQuoteSearch } from 'services/content/quotes/actions'
import { StoreThunkDispatch } from 'store/state'
import { firstValueFrom } from 'rxjs'

export function QuotesFeed() {
  const params = useParams()
  const dispatch = useDispatch<StoreThunkDispatch>()

  const feed = useMemo(() => {
    return {
      id: params.name,
      name: params.name,
      createdAt: new Date().toISOString()
    }
  }, [params.name])

  useEffect(() => {
    firstValueFrom(dispatch(saveQuoteSearch(feed.name || '', true)))
  }, [feed.name, dispatch])

  return (
    <QuotesFeedView feed={feed as QuoteFeed} gridView />
  )
}
